module.exports = __webpack_public_path__ + "img/icon_co2.d296e28f.png";